module.exports = __webpack_public_path__ + "img/expostyle_0985_flecked_grey.b1f7dbe2.jpg";